import { render, staticRenderFns } from "./JoinCode.vue?vue&type=template&id=0e161c16&scoped=true&"
import script from "./JoinCode.vue?vue&type=script&lang=js&"
export * from "./JoinCode.vue?vue&type=script&lang=js&"
import style0 from "./JoinCode.vue?vue&type=style&index=0&id=0e161c16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e161c16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VFlex,VLayout})
